import CompareMixin from '../components/filters/compare-mixin'
import { filters } from '../constants'
import { workflowFilterLabel } from './shared'

export const workflowStatusDefinition = {
  type: filters.WORKFLOW_STATUS,
  nameKey: 'workflow_status',
  ledgerRequired: true,
  hasModalHelp: true,

  disabledOnFirmLevel() {
    return !Silverfin.currentFirmFeatures.supports_workflow_statuses
  },

  comparisonModes() {
    return [
      ...CompareMixin.computed.showAllComparisonMode(),
      ...CompareMixin.computed.isComparisonMode(),
      ...CompareMixin.computed.isNotComparisonMode(),
      ...CompareMixin.computed.untilStatusComparisonMode(),
      ...CompareMixin.computed.fromStatusComparisonMode(),
    ]
  },
  activeSubtitle(settings, getters) {
    const { comparisonMode, workflowStatusId } = settings

    const workflowLabel = workflowFilterLabel(settings, getters)

    if (comparisonMode === CompareMixin.TYPES.SHOW_ALL) {
      return workflowLabel
    } else {
      const label = comparisonMode.replace('status', '')

      const status = getters.getFilterDropdownValueLabel(
        'workflow_status',
        workflowStatusId
      )

      return `${workflowLabel} ${label} ${status}`
    }
  },

  serializeSettings(settings) {
    return {
      firm_workflow_id: settings.firmWorkflowId,
      partner_workflow_id: settings.partnerWorkflowId,
      workflow_status_id: settings.workflowStatusId,
      comparison_mode: settings.comparisonMode,
    }
  },

  deserializeSettings(params) {
    return {
      firmWorkflowId: params.firm_workflow_id,
      partnerWorkflowId: params.partner_workflow_id,
      workflowStatusId: params.workflow_status_id,
      comparisonMode: params.comparison_mode,
    }
  },
}
